import type { ReferenceData } from '@cinch-nx/data-search'
import { csvUtils } from '../../../utils'

const { makeCSV, parseCSV } = csvUtils
export function truncateSelectedValues(
  matchingValuesToDisplay: string[],
  length = 4,
  conjunction = 'or',
) {
  if (matchingValuesToDisplay.length <= 1) {
    return makeCSV(matchingValuesToDisplay)
  }
  const indexToSplitAt = Math.min(matchingValuesToDisplay.length - 1, length)
  const firstPart = matchingValuesToDisplay.slice(0, indexToSplitAt)
  const lastPart = matchingValuesToDisplay.slice(indexToSplitAt)
  const showPlusStyleEnding = matchingValuesToDisplay.length > length
  const lastPartFormatted = showPlusStyleEnding
    ? ` +\u00A0${lastPart.length}\u00A0more`
    : ` ${conjunction} ${lastPart[0]}`

  return makeCSV(firstPart, ', ') + lastPartFormatted
}

export function stringifyReferenceDataValue(
  numberTypeReferenceData: { label: string; value: number }[],
) {
  return numberTypeReferenceData.map((option) => ({
    value: option.value.toString(),
    label: option.label,
  }))
}

export function findSelectedOptionLabel(
  referenceData: ReferenceData[],
  selectedValue = '',
): string {
  return (
    referenceData.find((data: ReferenceData) => data.value === selectedValue)
      ?.label ?? selectedValue
  )
}

export function formatSelectionsArray(
  selections: string[],
  options: ReferenceData[],
) {
  return selections.map((selectedValue) =>
    findSelectedOptionLabel(options, selectedValue),
  )
}

export function formatSelections(selections: string, options: ReferenceData[]) {
  return parseCSV(selections).map((selectedValue) =>
    findSelectedOptionLabel(options, selectedValue),
  )
}
